// extracted by mini-css-extract-plugin
export default {"toolbar":"SMLFilterTabs_toolbar__BEeyP","seg":"SMLFilterTabs_seg__pW9cm","tab":"SMLFilterTabs_tab__r8G63","tabOn":"SMLFilterTabs_tabOn__ANgVJ","count":"SMLFilterTabs_count__dyRt6"};